export default __webpack_public_path__ + "static/media/sensors.6f43118a.jpg";